import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { StatusBadge, DataLabel } from "../components/common";

export default function EditorialCalendar() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/content").then((r) => setItems(r.data)); }, []);

  const dateOf = (c) => (c.published_at || c.updated_at || c.created_at || "").slice(0, 10);
  const groups = {};
  items.forEach((c) => { const d = dateOf(c) || "—"; (groups[d] = groups[d] || []).push(c); });
  const days = Object.keys(groups).sort().reverse();

  const fmt = (d) => d === "—" ? "Sans date" : new Date(d).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  return (
    <div>
      <div className="mb-6">
        <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-muted-foreground mb-1">Planification</div>
        <h1 className="font-serif text-4xl text-brand tracking-tight">Calendrier éditorial</h1>
        <p className="text-sm text-muted-foreground mt-1">Cycle autonome quotidien à 05:00 UTC · publication selon la fréquence définie dans Stratégie.</p>
      </div>

      <div className="space-y-6">
        {days.length === 0 && <div className="text-sm text-muted-foreground">Aucun contenu planifié.</div>}
        {days.map((d) => (
          <div key={d}>
            <DataLabel>{fmt(d)}</DataLabel>
            <div className="mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {groups[d].map((c) => (
                <div key={c.id} className="bg-white border border-border rounded-md p-4 border-l-2 border-l-brand/60">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">{c.content_type}</span>
                    <StatusBadge status={c.status} />
                  </div>
                  <div className="text-sm font-medium leading-snug line-clamp-2">{c.title_primary}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
